var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.001,
    height: 29.146,
    viewBox: "0 0 109.001 29.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3671",
    "data-name": "Group 3671",
    transform: "translate(-599.999 -612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g842",
    transform: "translate(599.964 612.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path835",
    d: "M37.335,52.528a28.291,28.291,0,0,1,2.3,3.392,17.735,17.735,0,0,1,1.261,3.2c.255.735.5.961,1.006.961.555,0,.81-.375,1.006-.961a18.039,18.039,0,0,1,1.216-3.137,35.108,35.108,0,0,1,3.407-4.818A29.812,29.812,0,0,0,50.9,46.3a11.84,11.84,0,0,0,1.156-5.148,10.233,10.233,0,0,0-1.141-4.758l-3.3.885L45.6,42.562l-.5.72L45,43.418l-.135.165-.225.27-.33.33-1.786,1.456L38.07,48.22Z",
    transform: "translate(-31.702 -30.937)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path833",
    d: "M6.635,58.433c1.1,2.491,3.182,4.667,4.607,6.589l7.549-8.945a3.962,3.962,0,0,1-2.987,1.4A3.866,3.866,0,0,1,11.918,53.6a4.141,4.141,0,0,1,.885-2.506L7.686,52.46Z",
    transform: "translate(-5.609 -43.431)",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path831",
    d: "M53.813,3.094a10.074,10.074,0,0,1,5.943,5.013L53.723,15.3a4.2,4.2,0,0,0,.885-2.506,3.91,3.91,0,0,0-3.872-3.872,4.064,4.064,0,0,0-3,1.381V5.765Z",
    transform: "translate(-40.541 -2.635)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path829",
    d: "M15.835,3.626A10.084,10.084,0,0,1,23.594-.006a10.375,10.375,0,0,1,3.092.465l-6.063,7.2H16.33Z",
    transform: "translate(-13.429 0)",
    fill: "#1a73e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path827",
    d: "M1.026,35.655a11.618,11.618,0,0,1-.991-4.8,10.105,10.105,0,0,1,2.386-6.558l4.788,4.037Z",
    transform: "translate(0 -20.653)",
    fill: "#ea4335"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Google_Local",
    "data-name": "Google Local",
    transform: "translate(630 631)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Google Local")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalLogo);
export default __webpack_public_path__ + "static/media/localLogo.485e015d.svg";
export { ForwardRef as ReactComponent };